import { useQuery } from "@tanstack/react-query";
import DashStatTile from "./v2/DashStatTile";
import { faCapsules } from "@fortawesome/free-solid-svg-icons";
import axios, { AxiosError } from "axios";
import { usePermissionModal } from "contexts/PermissionModalContext";

interface TopMedicamento {
  nome: string;
  quantidade: number;
  percentual: number;
}

const fetchTopMedicamentos = async (): Promise<TopMedicamento> => {
  const response = await axios.get("/api/dashboardStats/top-medicamentos");
  return response.data.data;
};

const DepartamentoMaisVendido = () => {
  const { getQueryRetryHandler } = usePermissionModal();

  const { data, isLoading, error } = useQuery<TopMedicamento, AxiosError>({
    queryKey: ["topMedicamentos"],
    queryFn: fetchTopMedicamentos,
    retry: getQueryRetryHandler({
      queryKey: ["topMedicamentos"],
      defaultMessage: "Você não possui permissão para visualizar o departamento mais vendido.",
      showModal: false,
    }),
  });

  const isAccessDenied = axios.isAxiosError(error) && error?.response?.status === 403;
  if (isAccessDenied) return null;

  const temDepartamento = data && data.quantidade > 0;
  const departamentoNome = temDepartamento ? data.nome : "Sem dados no período";
  const percentual = temDepartamento ? data.percentual : 0;

  return (
    <DashStatTile
      label="Departamento Mais Vendido"
      value={departamentoNome}
      icon={faCapsules}
      variant="accent"
      size="name"
      isLoading={isLoading}
      footnote={temDepartamento ? `${percentual}% das vendas do período` : undefined}
    />
  );
};

export default DepartamentoMaisVendido;
